/*
 * @Author:
 * @Date: 2021-02-26 17:27:52
 * @Description:
 */
import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { START, END } from "./loading";
import { getToken } from "@/services/auth";
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 0
});

// request interceptor
service.interceptors.request.use(
  config => {
    START(); // 开启loading
    if (getToken()) {
      config.headers["X-Token"] = getToken();
      config.headers["Authorization"] = "Bearer " + getToken();
      // config.headers["siteid"] = store.getters.userType.key;
    }
    config.headers['wechatId'] = store.getters.weChatID;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    END(); // 关闭Loading
    const res = response.data;
    console.log("response data:", res);
    if (res.resultCode !== "000" && response.config.responseType != "blob") {
      Message({
        message: res.content || "Error",
        type: "error",
        duration: 5 * 1000
      });
      if (res.resultCode === "401") {
        // 登录失效重新登录，给出的提示，这里的resultCode。得后端结合使用，这里只是模拟
        store.dispatch("user/resetToken").then(() => {
          location.reload();
        });
      }

      return Promise.reject(new Error(res.content || "Error"));
    } else {
      return res;
    }
  },
  error => {
    END(); // 关闭Loading
    let errorMsg = error.message;
    if (error.response) {
      switch (error.response.status) {
        case 400:
          errorMsg = "请求错误！";
          break;
        case 401:
          errorMsg = "请求要求身份验证！";
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
          break;
        case 403:
          errorMsg = "服务器拒绝响应！";
          break;
        case 404:
          errorMsg = "服务器找不到请求的网页！";
          break;
        case 408:
          errorMsg = "服务器等候请求时发生超时！";
          break;
        case 501:
          errorMsg = "服务器无法识别请求！";
          break;
        case 502:
          errorMsg = "错误网关！";
          break;
        case 503:
          errorMsg = "服务器目前无法使用（由于超载或停机维护）！";
          break;
        case 504:
          errorMsg = "网关超时！";
          break;
        case 505:
          errorMsg = "服务器不支持请求中所用的 HTTP 协议版本！";
          break;
        default:
          errorMsg = "系统处理异常，请联系管理员！";
      }
    }
    Message({
      message: errorMsg,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
